function openImage(currentTarget) {
    let productSrc = currentTarget.getAttribute('data-src');

    const productImageModal = document.querySelector('.image-zoom');
    productImageModal.classList.add('open');

    const productImageSection = productImageModal.querySelector('.productImage-section');
    productImageSection.innerHTML += '<img class="img-fluid" src="' + productSrc + '" alt="image" />';
    document.body.style.overflowY = "hidden";
}

function closeImage(currentTarget) {
//   console.log(currentTarget);
  let closeimg = currentTarget.closest('.image-zoom');
  closeimg.classList.remove('open');
  document.body.style.overflowY = "auto";
  currentTarget.closest('.image-zoom').querySelector('.productImage-section').innerHTML = '';
}

const dynamicFAQs = document.querySelectorAll('.dynamic-block');
const questionsParent = document.querySelector('[data-questionsParent]');

dynamicFAQs.forEach(child => {
  questionsParent.appendChild(child);
});